// frontend/src/pages/SellerPackagesPage.jsx
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Edit, Trash2, Loader2, Eye } from 'lucide-react';
import { PageSEO } from '../components/SEO/PageSEO';
import api from '../services/api';

export const SellerPackagesPage = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      const response = await api.get('/products/packages/');
      setPackages(response.data.results || response.data || []);
    } catch (error) {
      console.error('Error fetching packages:', error);
    } finally {
      setLoading(false);
    }
  };

  const getPowerLabel = (power) => {
    const options = {
      3: '3 کیلووات',
      5: '5 کیلووات',
      6: '6 کیلووات',
      8: '8 کیلووات',
      10: '10 کیلووات',
      12: '12 کیلووات',
      15: '15 کیلووات',
      18: '18 کیلووات',
      20: '20 کیلووات',
      33: '33 کیلووات',
    };
    return options[power] || `${power} کیلووات`;
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Loader2 className="w-10 h-10 animate-spin text-blue-600" />
      </div>
    );
  }

  return (
    <>
      <PageSEO title="مدیریت پکیج‌ها | پنل فروشنده" noindex={true} />
      
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center mb-8">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">مدیریت پکیج‌ها</h1>
              <p className="text-sm text-gray-500 mt-1">مدیریت پکیج‌های خورشیدی</p>
            </div>
            <Link
              to="/seller/packages/new"
              className="bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-700"
            >
              <Plus className="w-5 h-5" />
              افزودن پکیج جدید
            </Link>
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">نام پکیج</th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">توان</th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">قیمت کل</th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">قیمت نهایی</th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">وضعیت</th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">عملیات</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {packages.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="px-6 py-12 text-center text-gray-500">
                        پکیجی یافت نشد
                      </td>
                    </tr>
                  ) : (
                    packages.map((pkg) => (
                      <tr key={pkg.id} className="hover:bg-gray-50 transition">
                        <td className="px-6 py-4 font-medium text-gray-900">{pkg.name}</td>
                        <td className="px-6 py-4">{getPowerLabel(pkg.power_rating)}</td>
                        <td className="px-6 py-4">{pkg.total_price?.toLocaleString()} تومان</td>
                        <td className="px-6 py-4 font-bold text-blue-600">
                          {(pkg.discount_price || pkg.total_price)?.toLocaleString()} تومان
                        </td>
                        <td className="px-6 py-4">
                          <span className={`px-2 py-1 text-xs rounded-full ${pkg.is_active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                            {pkg.is_active ? 'فعال' : 'غیرفعال'}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <div className="flex gap-2">
                            <Link to={`/packages/${pkg.slug}`} target="_blank" className="text-green-600 hover:text-green-800">
                              <Eye className="w-5 h-5" />
                            </Link>
                            <Link to={`/seller/packages/${pkg.slug}/edit`} className="text-blue-600 hover:text-blue-800">
                              <Edit className="w-5 h-5" />
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};